import React from 'react';
import DataTableCard from '../../../components/ui/DataTableCard';
import { useFetchList } from '../../../hooks/useFetchList';
import { activeBodyTemplate, lockedBodyTemplate, dateTimeBody } from '../../../utils/tableTemplates';

const COLUMNS = [
  { field: 'firstName', header: 'First name' },
  { field: 'lastName', header: 'Last name' },
  { field: 'emailAddress', header: 'Email' },
  { field: 'phoneNumber', header: 'Phone number' },
  { field: 'locked', header: 'isLocked', body: lockedBodyTemplate },
  { field: 'isActive', header: 'isActive', body: activeBodyTemplate },
  { field: 'creationTimestamp', header: 'Created at', body: dateTimeBody('creationTimestamp') },
  { field: 'lastUpdateTimestamp', header: 'Updated at', body: dateTimeBody('lastUpdateTimestamp') },
];

// Shared by the all-users, customers and employees profile reports; they only differ by endpoint and labels.
const UserProfileReportTable = ({ endpoint, title, exportName, emptyMessage }) => {
  const { rows } = useFetchList(endpoint);

  return (
    <DataTableCard
      title={title}
      exportName={exportName}
      columns={COLUMNS}
      rows={rows}
      emptyMessage={emptyMessage}
    />
  );
};

export default UserProfileReportTable;
